import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerLevelService {

  private API_URL = environment.API_URL;
  constructor(private http: HttpClient) { }

  public getCustomerDropDown(qParam: any, url: any): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);
  }

  public getAlgorithmsValues(qParam: any, url: any): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);

  }

  public getSalesBridgeValues(qParam: any, url: any): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);

  }

  public getSalesPercentageVal(qParam: any, url: any): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);

  }

  public getTop5Values(qParam: any, url: any): Observable<any> {
    return this.http.post(`${this.API_URL + url}`, qParam);

  }

  public getSalesByTrendBridgeValues(customerNames: any, url: any): Observable<any> {
     return this.http.post(`${this.API_URL + url}`, customerNames);
     
  }

  public getMarginBrigeValues(qParam: any, url) {
    return this.http.post(`${this.API_URL + url}`, qParam);

  }

  public getMarginPercentValues(qParam: any, url: any) {
    return this.http.post(`${this.API_URL + url}`, qParam);

  }


}
